import { render } from "./AddResultDialog.vue?vue&type=template&id=b12d32b0"
import script from "./AddResultDialog.vue?vue&type=script&lang=js"
export * from "./AddResultDialog.vue?vue&type=script&lang=js"

import "./AddResultDialog.vue?vue&type=style&index=0&id=b12d32b0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__